import {Component} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ServiceAppModels} from '../../../models/serviceapp-models';
import {MatDialogRef} from '@angular/material/dialog';
import Produkt = ServiceAppModels.Produkt;

@Component({
    selector: 'app-time-app-work-supply-products-dialog',
    templateUrl: './time-app-work-supply-products-dialog.component.html',
    styleUrl: './time-app-work-supply-products-dialog.component.scss'
})
export class TimeAppWorkSupplyProductsDialogComponent {
    protected selectedProductNumber: BehaviorSubject<Produkt | null> = new BehaviorSubject(null as any);

    constructor(private dialogRef: MatDialogRef<TimeAppWorkSupplyProductsDialogComponent>) {
        this.dialogRef.updatePosition({top: '3.75rem'});
    }

    protected save() {
        this.dialogRef.close(this.selectedProductNumber.getValue());
    }

    protected onProductSelected(product: Produkt | null) {
        if (!product || this.selectedProductNumber.getValue()?.productNo == product.productNo) {
            this.selectedProductNumber.next(null);
        } else {
            this.selectedProductNumber.next(product);
        }
    }
}
